import React from "react";

import Tippy from "@tippyjs/react";
import { isEmpty } from "lodash";

const BaseActionButton = ({
    hide,
    onClick,
    disabled,
    className,
    icon,
    tippy,
    tippySettings,
}) => {
    if (hide) {
        return <></>;
    }

    const buttonBody = (
        <button
            onClick={onClick || function () {}}
            disabled={disabled}
            className={className}
        >
            <i className={icon} />
        </button>
    );

    if (tippy || !isEmpty(tippySettings)) {
        return (
            <Tippy
                content={tippySettings?.content || ""}
                placement={tippySettings?.placement || "top"}
                animation={tippySettings?.animation || "scale"}
            >
                {buttonBody}
            </Tippy>
        );
    } else {
        return buttonBody;
    }
};

export default BaseActionButton;
